import { Route } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import React, { useCallback, useEffect } from "react"

import { getToken, logout } from "../services/helper"
import { setLoading } from "../redux/loading"
import { setUser } from "../redux/user"
import { IRedux } from "../services/types"
import ROUTES from "../services/routes"
import UserApi from "../services/api/User.api"
import useHistoryCustom from "../hooks/useHistoryCustom"

const PrivateRoute = ({ ...rest }: any) => {
  const history = useHistoryCustom()
  const dispatch = useDispatch()
  const user = useSelector((state: IRedux) => state.user)

  if (!getToken()) history.replace(ROUTES.LOGIN)

  const fetchUser = useCallback(async () => {
    try {
      if (user) return
      dispatch(setLoading(true))
      const userFetched = await new UserApi().getMe()
      dispatch(setUser(userFetched))
    } catch (e) {
      logout()
    } finally {
      dispatch(setLoading(false))
    }
  }, [dispatch, user])

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  if (!user) return null

  return <Route {...rest} />
}

export default PrivateRoute
